
//   URL Redirection
//   Homepage brands logo
  if (window.location.pathname === '/products/aero-bowls-brand') {
    window.location.replace('/collections/bowls-aero');
  }
  if (window.location.pathname === '/products/henselite-brand') {
    window.location.replace('/collections/henselite');
  }
  if (window.location.pathname === '/products/taylor-bowls-brand') {
    window.location.replace('/collections/taylor');
  }
  if (window.location.pathname === '/products/asics-brand') {
    window.location.replace('/collections/asics');
  }
  if (window.location.pathname === '/products/proline-brand') {
        window.location.replace('/collections/proline-lawn-bowls');
  }
   if (window.location.pathname === '/products/drakes-pride-brand') {
        window.location.replace('/collections/drakes-pride');
  }
  if (window.location.pathname === '/collections/shop-golf') {
        window.location.replace('/pages/shop-golf');
  }
   if (window.location.pathname === '/collections/shop-bowls') {
        window.location.replace('/pages/shop-bowls');
  }
//   


// popup 

 // function openPopup() {
 //   const overlay = document.getElementById('custom-popup-overlay');
 //   overlay.style.display = 'flex';
 // }
 // function closePopup() {
 //   document.getElementById('custom-popup-overlay').style.display = 'none';
 // }
  // Close when clicking outside the box
  //document.getElementById('custom-popup-overlay').addEventListener('click', function(e) {
 //   if (e.target === this) closePopup();
 // });
//********************************************************
//  Author  : Wayne
//  Date    : 05.06.2026
//  Desc    : Fixed error to ensuure info loaded in time
//********************************************************

document.addEventListener('DOMContentLoaded', () => {
  const overlay = document.getElementById('custom-popup-overlay');
  
  // Only attach the listener if the element actually exists
  if (overlay) {
    overlay.addEventListener('click', function(e) {
      if (e.target === this) closePopup();
    });
  }
});

function openPopup() {
  const overlay = document.getElementById('custom-popup-overlay');
  if (overlay) overlay.style.display = 'flex';
}

function closePopup() {
  const overlay = document.getElementById('custom-popup-overlay');
  if (overlay) overlay.style.display = 'none';
}

/*
// Greg Norman Combo
function gregNormanComboVariationTextArea() {
  const sizeArea = document.querySelector('.h-stack > .text-subdued');
  
  if (sizeArea?.innerText.includes('Greg Norman')) {
    sizeArea.innerText = 'Size:';
  }
}

let count = 0;
const intervalId = setInterval(() => {
  gregNormanComboVariationTextArea();
  count++;

  if (count >= 30) {
    clearInterval(intervalId);
  }
}, 1000);

// END Greg Norman Combo

*/
